import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import EditorPage from "./components/EditorPage";
import { Toaster } from "react-hot-toast";
import Login from "./components/Login.js";
import IntroPage from "./components/Intro.js";
import Register from "./components/register.js";
import Chat from "./components/chat";
import ThankYouPage from './components/ThankYouPage.jsx';
import FeedbackDashboard from './components/FeedbackDashboard.jsx';
import Suggestion from "./components/Suggestion.jsx";
import ProtectedRoute from "./components/ProtectedRoute";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import EditorTips from "./components/EditorTips";
import React, { useEffect } from "react";
import Contact from "./components/contact.jsx";




function App() {

  
  useEffect(() => {
    const servers = [
      process.env.REACT_APP_MAIN_BACKEND,
      process.env.REACT_APP_SIDESERVER,
      process.env.REACT_APP_CHATSERVER,
    ];

    servers.forEach((url) => {
        if (url) {
      fetch(url, { mode: "no-cors" }).catch(() => {});
    }
    });
  }, []);
  
  return (
    <>
      <div>
        <Toaster position="top-center" />
      </div>
      <Routes>
        <Route path="/" element={<IntroPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/login" element={<Login />} />
        <Route path="/editor-tips" element={<EditorTips />} />

        <Route path="/Suggestion" element={<Suggestion />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/feedback-dashboard" element={<FeedbackDashboard />} />
        <Route path="/chat" element={<Chat />} />
                <Route path="/contact" element={<Contact />} />


        {/* ✅ Protected Routes */}
        
      <Route path="/home" element={<Home />} />

<Route
  path="/editor/:roomId"
  element={
    <ProtectedRoute>
      <EditorPage />
    </ProtectedRoute>
  }
/>

      </Routes>
    </>
  );
}

export default App;
